import Modal from '@berlitzplatforms/micro.ui.modal'
import Spacer from '@berlitz/spacer'
import HR from '@components/HR'
import Switch from '@components/Switch'
import { uniqueId } from 'lodash'
import React, { useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import {
  ConfirmButton,
  Footer,
  Instruction,
  Option,
  OptionText,
  SwitchDiv,
  Title,
  UpperContent,
  Wrapper,
} from './style'

export interface ISessionModalPreference {
  open: boolean
  onClose: () => void
  onSubmit: (InstructorUnavailabilityAction: 'Cancel' | 'Substitute' | '', SavePref?: boolean) => void
}

const SessionPrefrenceModal = ({ open, onClose, onSubmit }: ISessionModalPreference) => {
  const compId = useMemo(() => uniqueId('cmp-sp-modal'), [])
  const [action, setAction] = useState<'' | 'Cancel' | 'Substitute'>('')
  const [savePref, setSavePref] = useState(false)

  return (
    <Wrapper>
      <Modal open={open} onClose={onClose}>
        <UpperContent>
          <Title>
            <FormattedMessage id="Session preferences" defaultMessage="Session preferences" />
          </Title>
          <Spacer size="sm" />
          <Instruction>
            <FormattedMessage
              id="If your instructor becomes unavailable for your booked session(s)"
              defaultMessage="If your instructor becomes unavailable for your booked session(s)"
            />
          </Instruction>
          <Spacer size="md" />
          <Spacer size="xxxs" />
          <div>
            <label>
              <Option
                type="radio"
                name="action"
                value="Cancel"
                checked={action === 'Cancel'}
                onChange={() => {
                  setAction('Cancel')
                  setSavePref(true)
                }}
              />
              <OptionText>
                <FormattedMessage id="Cancel the session/s" defaultMessage="Cancel the session/s" />
              </OptionText>
            </label>
            <Spacer size="xxs" />
            <label>
              <Option
                type="radio"
                name="action"
                value="Substitute"
                checked={action === 'Substitute'}
                onChange={() => {
                  setAction('Substitute')
                  setSavePref(true)
                }}
              />
              <OptionText>
                <FormattedMessage id="Assign a new instructor" defaultMessage="Assign a new instructor" />
              </OptionText>
            </label>
          </div>
        </UpperContent>
        <HR />
        <Footer>
          <SwitchDiv>
            <Switch
              name={`save-pref-modal-${compId}`}
              size="sm"
              onChange={() => {
                setSavePref(!savePref)
              }}
              checked={savePref}
            />
            <FormattedMessage
              id="Save preference for future bookings (optional)"
              defaultMessage="Save preference for future bookings (optional)"
            />
          </SwitchDiv>
          <ConfirmButton disabled={!action} onClick={() => action && onSubmit(action, savePref)}>
            <FormattedMessage id="Confirm" defaultMessage="Confirm" />
          </ConfirmButton>
        </Footer>
      </Modal>
    </Wrapper>
  )
}

export default React.memo(SessionPrefrenceModal)
